import { DocumentVersionORM } from 'src/types/orms'
import { ContentPageData, getSlideContentPageDataTitle } from 'src/hooks/useContentPageData/useContentPageData'
import { FileType } from '@alucio/aws-beacon-amplify/src/models'

/**
 * Generate thumbnail URL
 * @param DocumentVersionORM
 * @param pageNumber
 * @returns string (URL)
 */
export const getThumbURL = (
  documentVersionORM: DocumentVersionORM,
  pageNumber: number,
  contentPageData?: ContentPageData[],
) => {
  const pageThumbnail = contentPageData?.find((page) => page.documentPageNumber === pageNumber)?.htmlPageImage
  const isMultiPageHTML = documentVersionORM.model.type === FileType.HTML && !!documentVersionORM.meta.isMultiPageHTML

  if (isMultiPageHTML && pageThumbnail && documentVersionORM.model.convertedFolderKey) {
    return documentVersionORM.meta
      .assets
      .thumbnailKey
      ?.split('/')
      .slice(0, -1)
      .join('/') + `/${pageNumber}_medium_thumb.png` ?? ''
  }

  const thumbnailKey = documentVersionORM.meta.assets.thumbnailKey

  if (!thumbnailKey) {
    return ''
  }

  const thumbnailFolder = thumbnailKey.split('/').slice(0, -1).join('/')
  return `${thumbnailFolder}/${pageNumber}_medium_thumb.png`
}

/**
 * Generate slide title
 * @param DocumentVersionORM
 * @param pageNumber
 * @param contentPageData
 * @returns string (title)
 */
export const getSlideTitle = (
  documentVersionORM: DocumentVersionORM,
  pageNumber?: number,
  contentPageData?: ContentPageData[],
) : string => {
  if (!pageNumber || !contentPageData || contentPageData.length === 0) return ''
  return getSlideContentPageDataTitle(pageNumber - 1,
    contentPageData, documentVersionORM.model.type === FileType.PPTX)
}
